import { styled } from "../../theme";

export const Container = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
`;

export const ImageContainer = styled.div<{ usableHeight?: number }>`
  max-height: calc(100% - ${({ usableHeight }) => usableHeight}px);
  box-sizing: border-box;
  display: flex;
  justify-content: center;
`;
export const ImageButtonContainer = styled.div`
  min-height: 10%;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
`;

export const ImageTitleContainer = styled.div`
  min-height: 10%;
  align-self: flex-start;
  padding-top:1em;

  .title_level_2 {
    color: ${({ theme }) => theme.color.primary};
    text-align: left;
    padding-left: 2em;
    padding-bottom: 0.2em;
    border-bottom: 0.2em ${({ theme }) => theme.color.primary} solid;
    text-transform:uppercase;
    @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    padding-left:1em;
 
  }
  }
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    padding-top:5em;
   
    min-height: 3em;
  }
`;
